import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { MdCheckCircle, MdClose } from 'react-icons/md';
import { isEmbeddedInCommandCenter } from 'util/commandCenter';
import { modalOverlayBackgroundColor } from 'util/constants';
import sentIcon from './sentIcon.png';
import closeIcon from './closeIcon.png';
import './SentModal.scss';

const sentIconSlot = isEmbeddedInCommandCenter() ? (
  <MdCheckCircle className="sent-modal-cc-icon sent-modal-sent-icon" />
) : (
  <img src={sentIcon} alt="" />
);
const closeIconSlot = isEmbeddedInCommandCenter() ? (
  <MdClose className="sent-modal-cc-icon" />
) : (
  <img src={closeIcon} alt="" />
);

class SentModal extends PureComponent {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
  }

  // this instance method is called through a ref. We should refactor this to
  // use a prop instead.
  // eslint-disable-next-line react/no-unused-class-component-methods
  open = () => this.setState({ isOpen: true });

  close = () => this.setState({ isOpen: false });

  render() {
    if (!this.state.isOpen) {
      return null;
    }

    return (
      <div
        className="sent-modal-container"
        style={{
          background:
            isEmbeddedInCommandCenter() && modalOverlayBackgroundColor,
        }}
      >
        <div className="sent-modal">
          {sentIconSlot}
          <div className="sent-modal-text">{this.props.text}</div>
          <button onClick={this.close} className="sent-modal-close">
            {closeIconSlot}
          </button>
        </div>
      </div>
    );
  }
}

SentModal.propTypes = {
  text: PropTypes.string,
};

export default SentModal;
